<template>
    <svg
        aria-hidden="true"
        :class="`h-${size} w-${size}`"
        :fill="filled ? 'currentColor' : 'none'"
        stroke="currentColor"
        :stroke-width="strokeWidth"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        @click="$emit('click', $event)"
    >
        <v-icon-path :filled="filled" :type="type" />
    </svg>
</template>

<script>
    import VIconPath from '@/components/elements/VIconPath';

    export default {
        components: {
            VIconPath,
        },
        props: {
            filled: {
                default: false,
                type: Boolean,
            },
            size: {
                default: 6,
                type: [Number, String],
            },
            strokeWidth: {
                default: "1.7",
                type: [Number, String],
            },
            type: {
                required: true,
                type: String,
            },
        },
    };
</script>
